import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.infoDisclosure
  }, [_c('div', {
    class: _vm.$style.head,
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-expanded": String(_vm.isOpen)
    },
    on: {
      "click": _vm.toggle,
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments);
      }]
    }
  }, [_c('svg', {
    class: _vm.$style.infoIcon,
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM11 7h2v2h-2V7Zm0 4h2v6h-2v-6Z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', {
    class: _vm.$style.title
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('svg', {
    class: [_vm.$style.arrow, _defineProperty({}, _vm.$style.open, _vm.isOpen)],
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 15l-4.243-4.243 1.415-1.414L12 12.172l2.828-2.829 1.415 1.414z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": _vm.$style.expandActive,
      "leave-active-class": _vm.$style.expandActive
    },
    on: {
      "enter": _vm.onEnter,
      "after-enter": _vm.resetTransitionStyles,
      "leave": _vm.onLeave
    }
  }, [_vm.isOpen ? _c('div', {
    class: _vm.$style.text
  }, [_vm._t("default")], 2) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };